import fetch from "shared/fetch";
import { advertiserLabel, affiliateLabel } from "../utilities/organization_labels";
import SyncableModel from "shared/syncable_model";
import Loading from "shared/loading";

export default class DestinationCampaign extends SyncableModel {
  constructor(config) {
    const advertiserCampaignId = config.advertiserCampaignId;
    super({ "friendlyNameField": "text", "uniqueNameField": advertiserCampaignId });
    this.advertiserCampaignId = config.advertiserCampaignId;
    this.affiliateCampaignId = config.affiliateCampaignId;
    this.requiresAffiliate = config.requiresAffiliate;
    this.advertiserLabel = advertiserLabel();
    this.affiliateLabel = affiliateLabel();
    this.advertiserCampaignUrl = config.destinationAdvertiserCampaignUrl;
    this.affiliateCampaignUrl = this.buildAffiliateUrl(config.affiliateUrlBase);
    this.validateMoveDestinationUrl = config.validateMoveDestinationUrl;
  }

  buildAffiliateUrl(urlBase) {
    if (this.advertiserCampaignId) {
      const paramString = this.affiliateUrlParams();
      return `${urlBase}&${paramString}`;
    }
  }

  affiliateUrlParams() {
    const params = {
      "advertiser_campaign_id": this.advertiserCampaignId,
      "status": "Approved"
    };

    const paramsStrings = Object.keys(params).map((paramKey) => {
      return `${paramKey}=${params[paramKey]}`;
    });

    return paramsStrings.join("&");
  }

  campaignIds() {
    return {
      advertiserCampaignId: this.advertiserCampaignId,
      affiliateCampaignId: this.affiliateCampaignId
    };
  }

  saveData() {
    return {
      advertiser_campaign_id: this.advertiserCampaignId,
      affiliate_campaign_id:  this.affiliateCampaignId
    };
  }

  validate() {
    this.errors = [];

    if (this.advertiserCampaignId) {
      if (this.requiresAffiliate && !this.affiliateCampaignId) {
        this.errors.push(`${this.affiliateLabel} Campaign must be selected`);
      }
    } else {
      this.errors.push(`Campaign must be selected`);
    }
  }

  async ajaxValidations() {
    Loading.show();

    try {
      const response = await this.getValidated();
      this.selectErrors = response.errors;
    } catch (_error) {
      // This is to allow the flow to continue. Errors will be presented more clearly when the form is submitted in the VirtualLineMover save method
    }

    Loading.hide();
  }

  getValidated() {
    return fetch(
      this.validateMoveDestinationUrl,
      {
        method: "GET",
        data:   this.saveData()
      }
    );
  }
}
